import { useState } from 'react';
import image from '../assets/whatwedo.jpg';
import bgImage from '../assets/footer-bg.jpg'; 
import Footer from '../components/Footer';
import divider from '../assets/divider.png';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';

const carouselItems = [
  {
    id: 1,
    image: image 
  },
  {
    id: 2,
    image: image 
  },
  {
    id: 3,
    image: image 
  }
];

export default function PortfolioCarousel() {
  const [currentIndex] = useState(0);

  return (
    <>
      <SEOHead
        title={PAGE_SEO.portfolio.title}
        description={PAGE_SEO.portfolio.description}
        keywords={PAGE_SEO.portfolio.keywords}
        canonical={PAGE_SEO.portfolio.canonical}
        ogImage={PAGE_SEO.portfolio.ogImage}
      />
      <div className="portfolio-container">
      {/* Background decorative leaf image that covers full width */}
      <div 
        className="background-decoration" 
        style={{ backgroundImage: `url(${bgImage})` }}
      ></div>
      
      <div className="carousel-container">
        {/* Featured heading with divider */}
        <div className="featured-header">
          <h2>FEATURED</h2>
          <div className="divider-container">
          <img 
            src={divider} 
            alt="Decorative divider" 
            className="divider-image"
          />
        </div>
        </div>
        
        {/* Navigation arrows */}
   
  
          
          {/* Newspaper clipping content */}
          <div className="newspaper-clipping">
            <img 
              src={carouselItems[currentIndex].image} 
              alt="Newspaper article" 
              className="clipping-image" 
            />
          </div>
          

      </div>
      
      <style jsx>{`
        .portfolio-container {
          position: relative;
          width: 100%;
          max-width: 100%;
          margin: 0 auto;
          padding: var(--spacing-6) var(--left-right-padding);
          overflow: hidden;
          font-family: 'Times New Roman', serif;
        }

        .background-decoration {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          opacity: 1;
          z-index: 0;
        }

        .carousel-container {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
        }

        .featured-header {
          width: 100%;
          text-align: center;
          margin-bottom: 0px;
        }

        .featured-header h2 {
          color: var(--color-1);
          font-size: var(--spacing-6);
          font-weight: normal;
          letter-spacing: auto;
          margin-bottom: var(--spacing-1);
          font-family: var(--font-family-primary);
        }

        .divider-container {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        .divider-image {
          max-width: 300px;
        }

        .navigation-arrows {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          position: relative;
        }

        .arrow {
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background-color: transparent;
          z-index: 2;
        }

        .triangle-left {
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-bottom: 30px solid transparent;
          border-right: 50px solid #822c22;
        }

        .triangle-right {
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-bottom: 30px solid transparent; 
          border-left: 50px solid #822c22;
        }

        .newspaper-clipping {
          flex: 1;
          padding: 10px;
          max-width: 800px;
        }

        .clipping-image {
          width: 100%;
          height: auto;
          display: block;
        }

        @media (max-width: 768px) {
          .arrow{
            display: none;
          }

          .newspaper-clipping{
          padding: 0px;
          }
        }
      `}</style>
  
    </div>
    <Footer/>
    </>
  );
}